import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';

@Injectable({ providedIn: 'root' })
export class GalleryService {
  private api = environment.apiUrl;

  constructor(private http: HttpClient) {}

  pages(lang: string) {
    return this.http.get<any>(`${this.api}admin/gallery/pages`, { params: { lang } });
  }

  items(menu_page: number, lang: string) {
    return this.http.get<any>(`${this.api}admin/gallery/items`, { params: { lang, menu_page } });
  }

  storeItem(payload: any, lang: string) {
    return this.http.post<any>(`${this.api}admin/gallery/items`, payload, { params: { lang } });
  }

  sort(menu_page: number, ids: number[], lang: string) {
    return this.http.post<any>(`${this.api}admin/gallery/items/sort`, { menu_page, ids }, { params: { lang } });
  }

  toggleVisible(id: number, lang: string) {
    return this.http.post<any>(`${this.api}admin/gallery/items/${id}/toggle-visible`, {}, { params: { lang } });
  }

  delete(id: number, lang: string, soft = false) {
    return this.http.post<any>(`${this.api}admin/gallery/items/${id}/delete`, { soft }, { params: { lang } });
  }
}